import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau14 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const c = {
        bg: '#0d0221',
        neonPink: '#ff2d78',
        neonCyan: '#00e5ff',
        neonYellow: '#ffe600',
        neonPurple: '#b44fff',
        text: '#ffffff',
        textMuted: 'rgba(255,255,255,0.55)',
        cardBg: 'rgba(13,2,33,0.85)',
        cardBorder: 'rgba(255,45,120,0.5)'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div
            id={id}
            style={{
                width: width,
                minHeight: width / 1.3,
                fontFamily: 'SFUHelveticaCondensedBold',
                backgroundColor: c.bg,
                position: 'relative',
                overflow: 'hidden',
                padding: `${px * 2.5}px`
            }}
        >
            {/* Synthwave grid lines — horizontal */}
            {[...Array(12)].map((_, i) => (
                <div key={`h${i}`} style={{
                    position: 'absolute',
                    left: 0, right: 0,
                    top: `${(i / 12) * 100}%`,
                    height: `1px`,
                    background: i < 6
                        ? `rgba(255,45,120,${0.04 + i * 0.01})`
                        : `rgba(0,229,255,${0.04 + (i - 6) * 0.01})`,
                    zIndex: 0
                }} />
            ))}
            {/* Vertical grid lines */}
            {[...Array(16)].map((_, i) => (
                <div key={`v${i}`} style={{
                    position: 'absolute',
                    top: 0, bottom: 0,
                    left: `${(i / 16) * 100}%`,
                    width: '1px',
                    background: 'rgba(255,45,120,0.06)',
                    zIndex: 0
                }} />
            ))}

            {/* Glow bottom strip (synthwave sunset) */}
            <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                height: `${px * 8}px`,
                background: `linear-gradient(to top, rgba(255,45,120,0.25) 0%, transparent 100%)`,
                zIndex: 0
            }} />

            <div style={{ position: 'relative', zIndex: 1 }}>

                {/* ===== HEADER ===== */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: `${px * 2.5}px`,
                    padding: `${px * 1.8}px ${px * 2}px`,
                    background: 'rgba(255,45,120,0.08)',
                    border: `1px solid rgba(255,45,120,0.4)`,
                    borderRadius: `${px * 1.2}px`,
                    boxShadow: `0 0 20px rgba(255,45,120,0.15), 0 0 40px rgba(0,229,255,0.05), inset 0 0 20px rgba(180,79,255,0.05)`
                }}>
                    <Image src={dataSeason?.logo} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain', filter: `drop-shadow(0 0 6px ${c.neonPink})` }} />

                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <h1 style={{
                            color: c.text,
                            fontSize: `${px * 5}px`,
                            textTransform: 'uppercase',
                            margin: 0,
                            fontStyle: 'italic',
                            letterSpacing: `${px * 0.2}px`,
                            textShadow: `0 0 15px ${c.neonPink}, 0 0 30px ${c.neonPink}, 0 0 60px rgba(255,45,120,0.3)`
                        }}>
                            {t(titleTemplate(dataSchedules[0]?.dataGo))}
                        </h1>
                        <h2 style={{
                            color: c.neonCyan, fontSize: `${px * 2.2}px`,
                            textTransform: 'uppercase', margin: `${px * 0.5}px 0 0`,
                            textShadow: `0 0 8px ${c.neonCyan}`, letterSpacing: `${px * 0.3}px`
                        }}>
                            {dataSeason?.name}
                        </h2>

                        {t(numberRound) === numberRound && (
                            <div style={{
                                display: 'inline-block',
                                border: `2px solid ${c.neonYellow}`,
                                color: c.neonYellow,
                                padding: `${px * 0.3}px ${px * 2.5}px`,
                                borderRadius: `${px * 0.4}px`,
                                fontSize: `${px * 2}px`,
                                fontWeight: 'bold',
                                marginTop: `${px * 0.8}px`,
                                textShadow: `0 0 8px ${c.neonYellow}`,
                                boxShadow: `0 0 10px rgba(255,230,0,0.2)`
                            }}>
                                {t('round')} {numberRound}
                            </div>
                        )}
                        {t(numberRound) && t(numberRound) !== numberRound && (
                            <div style={{
                                display: 'inline-block',
                                border: `2px solid ${c.neonYellow}`,
                                color: c.neonYellow,
                                padding: `${px * 0.3}px ${px * 2.5}px`,
                                borderRadius: `${px * 0.4}px`,
                                fontSize: `${px * 2}px`,
                                fontWeight: 'bold',
                                marginTop: `${px * 0.8}px`,
                                textShadow: `0 0 8px ${c.neonYellow}`,
                                boxShadow: `0 0 10px rgba(255,230,0,0.2)`
                            }}>
                                {t(numberRound)}
                            </div>
                        )}
                    </div>

                    <Image src={img} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain', filter: `drop-shadow(0 0 6px ${c.neonCyan})` }} />
                </div>

                {/* ===== MATCH CARDS — 2 COLUMNS ===== */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: `${px * 1.5}px` }}>
                    {dataSchedules[0]?.dataGo
                        ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                        ?.map((i, idx) => (
                            <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} c={c} />
                        ))}
                </div>

                {/* ===== SPONSORS ===== */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{
                        marginTop: `${px * 3}px`,
                        border: `1px solid rgba(255,45,120,0.3)`,
                        borderRadius: `${px}px`,
                        padding: `${px * 1.5}px ${px * 2}px`,
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        flexWrap: 'wrap', gap: `${px * 2}px`,
                        background: 'rgba(255,45,120,0.05)',
                        boxShadow: `inset 0 0 15px rgba(255,45,120,0.05)`
                    }}>
                        {sponsorData?.slice(0, 10)?.map((s, idx) => (
                            <Image key={idx} src={s.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
                        ))}
                    </div>
                )}

                {/* FOOTER */}
                <p style={{ textAlign: 'right', color: 'rgba(255,45,120,0.5)', fontSize: `${px * 1.7}px`, marginTop: `${px * 1.2}px`, letterSpacing: '3px' }}>
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}
                </p>
            </div>
        </div>
    )
}

// ===================== ITEM =====================
const Item = React.memo(
    ({ data, px, classCustom, idx, c }) => {
        const { t } = useTranslation()

        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        // Alternate pink / cyan border for visual rhythm
        const borderColor = idx % 2 === 0 ? c.neonPink : c.neonCyan
        const glowColor = idx % 2 === 0 ? 'rgba(255,45,120,0.2)' : 'rgba(0,229,255,0.16)'

        return (
            <div style={{
                width: `calc(50% - ${px * 0.75}px)`,
                background: c.cardBg,
                border: `1px solid ${borderColor}`,
                borderRadius: `${px * 1}px`,
                padding: `${px * 1.8}px ${px * 1.5}px`,
                display: 'flex',
                alignItems: 'center',
                gap: `${px * 1}px`,
                position: 'relative',
                overflow: 'hidden',
                boxShadow: `0 0 18px ${glowColor}, inset 0 0 12px rgba(13,2,33,0.8)`,
                minHeight: `${px * 11}px`
            }}>
                {/* Neon top line accent */}
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: `${px * 0.25}px`, background: `linear-gradient(90deg, transparent, ${borderColor}, transparent)` }} />

                {/* Home team */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.6}px` }}>
                    <Image
                        src={data?.homeTeam?.logo}
                        style={{
                            width: `${px * 7}px`, height: `${px * 7}px`,
                            borderRadius: '50%', objectFit: 'cover',
                            border: `2px solid ${c.neonPink}`,
                            boxShadow: `0 0 10px rgba(255,45,120,0.5)`,
                            backgroundColor: '#fff'
                        }}
                    />
                    <Name propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} color={c.text} />
                </div>

                {/* Center: time / score */}
                <div style={{
                    flexShrink: 0,
                    minWidth: `${px * 22}px`,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: `${px * 0.5}px`
                }}>
                    {data?.isCompleted ? (
                        <>
                            <div style={{
                                background: 'rgba(0,0,0,0.6)',
                                border: `2px solid ${c.neonYellow}`,
                                color: c.neonYellow,
                                fontSize: `${px * 3.6}px`,
                                fontWeight: 900,
                                padding: `${px * 0.4}px ${px * 1.5}px`,
                                borderRadius: `${px * 0.5}px`,
                                letterSpacing: '2px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                textShadow: `0 0 10px ${c.neonYellow}`,
                                boxShadow: `0 0 15px rgba(255,230,0,0.3)`,
                                minWidth: `${px * 18}px`
                            }}>
                                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                            </div>
                            {data?.hasPenalty && (
                                <span style={{ color: '#fc0366', fontSize: `${px * 1.4}px`, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                    PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore}
                                </span>
                            )}
                            <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center' }}>
                                {formatDateTime(data?.dateTime, 'dateTime')}
                            </span>
                        </>
                    ) : (
                        <>
                            <div style={{
                                border: `2px solid ${c.neonCyan}`,
                                color: c.neonCyan,
                                fontSize: `${px * 3.2}px`,
                                fontWeight: 900,
                                padding: `${px * 0.4}px ${px * 1.5}px`,
                                borderRadius: `${px * 0.5}px`,
                                letterSpacing: '2px',
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                textShadow: `0 0 10px ${c.neonCyan}`,
                                boxShadow: `0 0 15px rgba(0,229,255,0.25)`,
                                minWidth: `${px * 16}px`
                            }}>
                                {formatDateTime(data?.dateTime, 'time')}
                            </div>
                            <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center' }}>
                                {formatDateTime(data?.dateTime, 'date')}
                            </span>
                            {data?.stadium && (
                                <span style={{ color: c.textMuted, fontSize: `${px * 1.2}px`, textAlign: 'center', maxWidth: `${px * 14}px`, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {data.stadium}
                                </span>
                            )}
                        </>
                    )}
                </div>

                {/* Away team */}
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.6}px` }}>
                    <Image
                        src={data?.awayTeam?.logo}
                        style={{
                            width: `${px * 7}px`, height: `${px * 7}px`,
                            borderRadius: '50%', objectFit: 'cover',
                            border: `2px solid ${c.neonCyan}`,
                            boxShadow: `0 0 10px rgba(0,229,255,0.4)`,
                            backgroundColor: '#fff'
                        }}
                    />
                    <Name propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} color={c.text} />
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

// ===================== NAME =====================
const Name = React.memo(
    ({ name, px, propClass, color }) => {
        const reSizeBasedOnWidth = () => {
            const el = document.querySelector(`.${propClass}`)
            const container = document.querySelector(`.contain${propClass}`)
            if (!el || !container) return
            const fontSize = window?.getComputedStyle(el)?.fontSize
            el.style.fontSize = parseFloat(fontSize) - 0.2 * px + 'px'
            if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
        }
        const processInput = () => {
            const el = document.querySelector(`.${propClass}`)
            if (!el) return
            el.innerHTML = name
            el.style.fontSize = px * 2.2 + 'px'
            reSizeBasedOnWidth()
        }
        React.useEffect(() => { processInput() }, [name])

        return (
            <div
                className={`contain${propClass}`}
                style={{ width: '100%', height: `${px * 7}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}
            >
                <h2
                    className={propClass}
                    style={{ color: color, textAlign: 'center', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2, fontSize: `${px * 2.2}px` }}
                />
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

// ===================== IMAGE =====================
const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) getBase64(props.src).then(r => setData(r))
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau14, areEqual)
